// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W8nUI","content":"styles_content__XO86F"};